import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { anyLinkedTaskDisabledSchedule, userCanEditSchedule, userCanEnableLinkedTask } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../bootstrap/redux/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IScheduleInfo } from '../types/IScheduleInfo';
import { scheduleEnableLinkedTask } from './ScheduleMenuActions';

export const ScheduleEnableLinkedTaskAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.EnableLinkedTask,
  translateName: Messages.linkedTasksEnable,
  isVisible: (targetItems: IScheduleInfo[], state: AppState) => {
    return targetItems.length > 0 && userCanEditSchedule(state, targetItems) && userCanEnableLinkedTask(targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[]) => {
    return anyLinkedTaskDisabledSchedule(targetItems);
  },
  createReduxAction: (targetItems: IScheduleInfo[]) => scheduleEnableLinkedTask(targetItems)
};
